import { render } from "./productNewVersionBanner.vue?vue&type=template&id=158025cf&scoped=true&ts=true"
import script from "./productNewVersionBanner.vue?vue&type=script&lang=ts"
export * from "./productNewVersionBanner.vue?vue&type=script&lang=ts"

import "./productNewVersionBanner.vue?vue&type=style&index=0&id=158025cf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158025cf"]])

export default __exports__